import { androidPrinter } from './mealbill-android.mjs';

// No mode setting: absent profile selects Manager; every configured profile selects direct.
// Never catch a direct failure here to invoke the other destination.
export async function routeMobilePrint(printer, { direct, spool }) {
  const result = await androidPrinter.getPrintRoute(printer);
  if (result.destination === 'direct' && result.profile) return direct(result.profile);
  if (result.destination === 'manager' && result.profile === null) return spool();
  throw new Error('Cannot determine the print destination. No print was submitted.');
}
